<div class="indicator indicator-{{ size }} typo-body2">
    {{ amount > 9 ? '9+' : amount }}
</div>
